module.exports = __webpack_public_path__ + "static/media/fernando_new.6f7501ad.PNG";